import { useCallback, useMemo, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { SuggestionExecutionResult, SuggestionItem } from './types';
import { filterSuggestions } from './filterSuggestions';
import { executeSuggestion } from './executeSuggestion';
import { ALL_SUGGESTIONS } from './suggestions';

export function useAutoSuggestions(domainIdentifier: string) {
  const client = useApolloClient();
  const [inputValue, setInputValue] = useState('');

  const filteredSuggestions = useMemo(
    () => inputValue.startsWith('/') ? filterSuggestions(inputValue.slice(1), ALL_SUGGESTIONS) : [],
    [inputValue],
  );

  const showDropdown = filteredSuggestions.length > 0;

  const selectSuggestion = useCallback(
    async (item: SuggestionItem, timeRange?: { startTime: number; endTime: number }): Promise<SuggestionExecutionResult> => {
      setInputValue('');
      return executeSuggestion(item, domainIdentifier, client, timeRange);
    },
    [domainIdentifier, client],
  );

  const clearSuggestions = useCallback(() => {
    setInputValue('');
  }, []);

  return {
    suggestions: ALL_SUGGESTIONS,
    filteredSuggestions,
    inputValue,
    showDropdown,
    setInputValue,
    selectSuggestion,
    clearSuggestions,
  };
}
